var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/social-Copy-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 24C23.5523 24 24 23.5523 24 23L24 1C24 0.447715 23.5523 0 23 0L1 0C0.447715 0 0 0.447715 0 1L0 23C0 23.5523 0.447715 24 1 24L23 24Z",
    id: "White_4_",
    fill: "#39579A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25959 20.3751L3.25959 10.8751L0 10.8751L0 7.37514L3.25959 7.37514L3.25959 4.78783C3.25959 1.68794 5.15289 0 7.9182 0C9.24281 0 10.3812 0.09862 10.713 0.1427L10.713 3.38226L8.79513 3.38313C7.2912 3.38313 7 4.09777 7 5.14646L7 7.37514L10.5 7.37514L10 10.8751L7 10.8751L7 20.3751L3.25959 20.3751Z",
    transform: "translate(9.5 3.62486)",
    id: "White_2_",
    fill: "#FFFFFF",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.7bbf06f75ff74619f14a9174d63f5d73.svg";
export { ForwardRef as ReactComponent };